import React from 'react';
import Header from '../components/common/Header/Header';
// import Footer from '../components/common/Footer/Footer';

export default function ErrorPage() {
  return (
    <>
      <Header />
      <div className="notfoundBox">
        <img
          src="https://akam.cdn.jdmagicbox.com/images/icontent/newwap/cssupport/404ErrorImage.svg"
          className="notfoundImage"
          alt="notfoundImage"
        />
        <div className="font13 fw600 color111 mt-20"> The page you are looking for doesn&apos;t exist. </div>
      </div>
      {/* {show && <Footer />} */}
    </>
  );
}
